import { Environment, MovinmotionApplication } from '../models/environment';

export const environment: Environment = {
  environment: 'test-6',
  production: true,
  api: {
    movinmotionBackend: 'https://back.app.test-6.movinmotion.net',
    movinmotionService: 'https://services.test-6.movinmotion.net',
  },
  appEndpoints: {
    talents: '/api/talent/v1',
    core: '/api/core/v1',
    filmfrance: 'api/filmfrance/v1',
    nda: '/api/nda/v1',
    movinmotion: '/api/movinmotion/v1',
  },
  authentication: {
    url: 'https://accounts.app.test-6.movinmotion.net',
    sessionExpiredPath: '/session-expired',
    queryParamKeys: {
      redirectUrl: 'mmr',
      resetPassword: 'mmrp',
      changePassword: 'mmcp',
      email: 'mme',
      language: 'mml',
      display: 'mmd',
    },
  },
  apps: {
    core: 'https://entreprise.app.test-6.movinmotion.net',
    employeur: 'https://employeur.app.test-6.movinmotion.net',
    worker: 'https://salarie.app.test-6.movinmotion.net',
    compta: 'https://compta.app.test-6.movinmotion.net',
    talents: 'https://talents.app.test-6.movinmotion.net',
    insurance: 'https://assurance.app.test-6.movinmotion.net',
    socialPlay: 'https://app.test-6.movinmotion.net',
    social: 'https://social.app.test-6.movinmotion.net',
    admin: 'https://admin.app.test-6.movinmotion.net',
    movinmotion: 'https://www.movinmotion.com',
  },
  movinmotionAppUrls: {
    [MovinmotionApplication.core]: 'https://entreprise.app.test-6.movinmotion.net',
    [MovinmotionApplication.accounting]: 'https://compta.app.test-6.movinmotion.net',
    [MovinmotionApplication.worker]: 'https://salarie.app.test-6.movinmotion.net',
    [MovinmotionApplication.social]: 'https://app.test-6.movinmotion.net',
    [MovinmotionApplication.nda]: 'https://social.app.test-6.movinmotion.net',
    [MovinmotionApplication.talents]: 'https://talents.app.test-6.movinmotion.net',
    [MovinmotionApplication.odalie]: 'https://odalie2.app.test-6.movinmotion.net',
    [MovinmotionApplication.adminBo]: 'https://admin.app.test-6.movinmotion.net',
  },
  thirdParty: {
    siren: {
      endpoint: 'https://api.insee.fr/api-sirene/3.11',
      token: '30bb2afa-df6f-4447-bb2a-fadf6f144710',
    },
    googlePlaces: 'AIzaSyA9EB87DHCztCEOmBNKHC4k7erUcPwr0lw',
    yousign: {
      sandbox: true,
    },
    mixpanel: {
      token: '668a9eba9515c4e5bacd50ebbb8adee5',
      name: 'MM test',
    },
    axeptio: {
      clientId: '6501875f451c3565dc89dda9',
      cookiesVersion: 'movinmotion - application - test-fr',
    },
  },
  bucket: {
    avatars: 'mm-saas-test-6-avatars',
  },
  cookieDomain: '.app.test-6.movinmotion.net',
  captcha: { enabled: true, siteKey: '6LcftW0sAAAAAICHfznsz3Qsg8fpd_8CT6Ca54_o' },
  featureToggles: { monCompte: true },
};
